(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yc-collection-promo"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('yc-collection-promo')) {
    customElements.define('yc-collection-promo', class extends HTMLElement {
      connectedCallback() {
        this.panel = this.querySelector('.yc-promo-panel');
        if (!this.panel) return;
        this.row = document.createElement('li');
        this.row.className = 'yc-promo-row';
        this.row.dataset.promoSection = this.dataset.sectionId;
        this.schedule = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.place());
        };
        this.select = event => {
          if (String(event.detail?.sectionId) !== this.dataset.sectionId) return;
          this.place();
          if (!this.panel.hidden) this.panel.scrollIntoView({block: 'center', behavior: 'instant'});
        };
        this.observer = new MutationObserver(this.schedule);
        this.resizeObserver = new ResizeObserver(entries => {
          const width = entries[0]?.contentRect.width;
          if (width !== this.gridWidth) { this.gridWidth = width; this.schedule(); }
        });
        this.observer.observe(document.querySelector('main') || document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['product-grid-view']});
        window.addEventListener('popstate', this.schedule);
        window.addEventListener('resize', this.schedule);
        document.addEventListener('shopify:section:select', this.select);
        this.place();
      }
      place() {
        if (!this.isConnected) return;
        if (this.dataset.placement === 'normal') {
          this.panel.hidden = false;
          return;
        }
        const grid = document.querySelector('#ResultsList .product-grid');
        if (grid !== this.observedGrid) {
          this.resizeObserver.disconnect();
          this.observedGrid = grid;
          this.gridWidth = undefined;
          if (grid) this.resizeObserver.observe(grid);
        }
        const cards = grid ? Array.from(grid.children).filter(node => node.matches('[data-product-id]')) : [];
        const params = new URLSearchParams(location.search);
        const filtered = [...params.keys()].some(key => key.startsWith('filter.')) || /\/tagged\//.test(location.pathname);
        const tracks = grid ? getComputedStyle(grid).gridTemplateColumns.match(/(?:^|\s)[\d.]+px(?=\s|$)/g) : null;
        const columns = Math.max(1, tracks?.length || 1);
        const after = Math.ceil(Number(this.dataset.after) / columns) * columns;
        const visible = grid && grid.classList.contains('product-grid--grid') && grid.getAttribute('product-grid-view') !== 'zoom-out' && cards.length > after && cards[0]?.dataset.page === '1' && !(this.dataset.hideFiltered === 'true' && filtered);
        if (!visible) {
          this.panel.hidden = true;
          if (this.panel.parentNode !== this) this.append(this.panel);
          this.row.remove();
          return;
        }
        this.panel.hidden = false;
        if (this.panel.parentNode !== this.row) this.row.append(this.panel);
        const anchor = cards[after - 1];
        if (this.row.parentNode !== grid || this.row.previousElementSibling !== anchor) anchor.after(this.row);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.frame);
        window.removeEventListener('popstate', this.schedule);
        window.removeEventListener('resize', this.schedule);
        document.removeEventListener('shopify:section:select', this.select);
        if (this.panel && this.panel.parentNode !== this) this.append(this.panel);
        this.row?.remove();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
